// General
import "./ekyc-decision-element.scss";
// Static Data
import routeConst from "../../../const/routeConst";
// i18next
import { useTranslation, Trans } from "react-i18next";
// Custom Hooks
import useCustomNavigate from "../../utility/custom-hooks/useCustomNavigate-hook";
import AssetManager from "../../utility/manager/asset-manager/asset-manager";

const EkycDecisionElement = (props) => {
  const { notificationId, ekycStatus, message, isSeen, timestamp } = props;

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();
  const getAsset = AssetManager();

  // Event Handlers | Button
  const onRedirectToEkyc = () => {
    if (ekycStatus === "approved") return;

    onNavigate(routeConst.verify.ekyc.onboarding.path);
  };

  return (
    <div
      id="ekyc-decision-element-subcomponent"
      className={isSeen ? "" : "notification-unseen"}
      onClick={onRedirectToEkyc}
    >
      <div className="payment-icon-container">
        <img
          className="ekyc-icon"
          src={getAsset(
            ekycStatus === "approved" ? "ekycVerifiedIcon" : "ekycRejectedIcon"
          )}
        />
      </div>

      <div className="coins-payment-body-container">
        <div>
          {ekycStatus === "approved"
            ? t("notification.ekyc_approved")
            : message}
        </div>
      </div>
    </div>
  );
};

export default EkycDecisionElement;
